import React, { useState } from "react";
import StudentHeader from "../components/StudentHeader";
import Footer from "../components/Footer";
import { Container, Card, Form, Row, Col, Button } from "react-bootstrap";
import {
  FaFolder,
  FaEye,
  FaTrashAlt,
  FaUndoAlt,
  FaRegCalendarAlt,
  FaRegClock,
} from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { DataGrid } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
const DataSubfolder = () => {
  return (
    <div className="dashbrd_pg">
      <StudentHeader />
      <div className="schl_prfl_pg">
        <Container className="custm_container">
          <div className="prfl_wrap">
            <Card className="pg_card">
              <Card.Body>
                <div className="card_hdng">
                  <h4 className="mb-0">Data Reports</h4>
                </div>
                <div className="files_cards">
                  <Row>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card mb-3">
                          <div className="fldr_icn txt_prpl">
                            <FaFolder />
                          </div>
                          <h5>RN</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card crd_orng mb-3">
                          <div className="fldr_icn txt_orng">
                            <FaFolder />
                          </div>
                          <h5>VN</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card crd_grn mb-3">
                          <div className="fldr_icn txt_grn">
                            <FaFolder />
                          </div>
                          <h5>CNA</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card crd_blu mb-3">
                          <div className="fldr_icn txt_blu">
                            <FaFolder />
                          </div>
                          <h5>SENIOR NURSING STUDENTS</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card mb-3">
                          <div className="fldr_icn txt_prpl">
                            <FaFolder />
                          </div>
                          <h5>SENIOR ALLIED HEALTH STUDENTS</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card crd_orng mb-3">
                          <div className="fldr_icn txt_orng">
                            <FaFolder />
                          </div>
                          <h5>COVID-19 VACCINE STUDENT NUMBERS</h5>
                        </div>
                      </a>
                    </Col>
                    <Col md={3}>
                      <a href="/student-subfolder-file">
                        <div className="file_card crd_grn mb-3">
                          <div className="fldr_icn txt_grn">
                            <FaFolder />
                          </div>
                          <h5>FLU VACCINE STUDENT NUMBERS</h5>
                        </div>
                      </a>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default DataSubfolder;
